import { render, staticRenderFns } from "./messageCenter.vue?vue&type=template&id=cba3913c&scoped=true"
import script from "./messageCenter.vue?vue&type=script&lang=js"
export * from "./messageCenter.vue?vue&type=script&lang=js"
import style0 from "./messageCenter.vue?vue&type=style&index=0&id=cba3913c&prod&lang=scss&scoped=true"
import style1 from "./messageCenter.vue?vue&type=style&index=1&id=cba3913c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba3913c",
  null
  
)

export default component.exports